import { AgxEmptyState, AgxSpacer } from '@urbanx/agx.ui-components2'
import { JSX } from 'react'

interface AwaitingAgentApprovalBlockerProps {
  onApprovalReceived: () => void
}

export const AwaitingAgentApprovalBlocker = ({ 
  onApprovalReceived 
}: AwaitingAgentApprovalBlockerProps): JSX.Element => {
  return (
    <AgxSpacer
      fill
      contentJustification="center"
      contentAlignment="center"
    >
      <AgxEmptyState
        variant="advanced"
        glyphType="locked"
        actionButtons={[
          {
            label: 'Approval Received',
            isPrimary: true,
            order: 1,
            onClick: onApprovalReceived,
          },
        ]}
        label="Awaiting Agent Approval"
      />
    </AgxSpacer>
  )
}
